import type { Texture } from 'pixi.js';

/**
 * **标记这张纹理由我们显式管理生命周期，Pixi 的 GC 不许回收它。**
 *
 * 背景场、牌面、卡牌遮罩、裂缝这些 `RenderTexture` 都是**长期持有**的：
 * 引用存在缓存 / 字段里，创建方比 Pixi 更清楚它什么时候该销毁。
 *
 * ⚠️ 但 Pixi v8.15+ 的 `GCSystem` 会把「一段时间没被绑定」的 `TextureSource`
 * 销毁掉。对长期持有的 RT 来说这是**误伤**：下一次绑定就变成
 * `RENDER WARNING: there is no texture bound to the unit N`，
 * 于是背景和一部分牌面渲染成纯黑 —— 而且**跟设备/时机有关**
 * （GC 什么时候跑、哪张贴图最近没被绑，都不一定）。
 *
 * 关掉 `autoGarbageCollect` 就把生命周期拿回自己手里：该销毁的地方
 * （缓存失效、整层重建）本来就会显式 `destroy()`。对已经关过的贴图再调一次无害。
 */
export function keepAlive<T extends Texture>(texture: T): T {
  texture.source.autoGarbageCollect = false;
  return texture;
}

/** 这张贴图（或它的 source）还活着吗。缓存把死贴图递回来时用它兜底 */
export function isTextureAlive(texture: { source: { destroyed?: boolean } | null } | null | undefined): boolean {
  return texture !== null && texture !== undefined && texture.source !== null && texture.source.destroyed !== true;
}
